(() => {
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const seen = new WeakSet();
  const animations = new Set();
  let revealObserver;

  const initializeReveals = (root = document) => {
    if (reducedMotion.matches || navigator.connection?.saveData || !Element.prototype.animate || !window.IntersectionObserver) return;

    revealObserver ||= new IntersectionObserver((entries) => {
      entries.forEach(({ target, isIntersecting }) => {
        if (!isIntersecting || reducedMotion.matches) return;
        revealObserver.unobserve(target);
        // Content remains visible before JS runs and after interruption.
        const animation = target.animate([
          { opacity: 0.88, transform: 'translateY(12px)' },
          { opacity: 1, transform: 'translateY(0)' }
        ], { duration: 420, easing: 'cubic-bezier(.2,.65,.25,1)' });
        animations.add(animation);
        animation.finished.catch(() => {}).finally(() => animations.delete(animation));
      });
    }, { threshold: 0.15 });

    root.querySelectorAll('#MainContent .ry-finder__header, #MainContent .ry-comparison__header, #MainContent .ry-trust__header, #MainContent .ry-routine__header, #MainContent .ry-routine__item, #MainContent .ugc-gallery__header, #MainContent .founder-note__content').forEach((element) => {
      if (seen.has(element)) return;
      seen.add(element);
      // Never animate the first viewport or a restored scroll position.
      if (element.getBoundingClientRect().top >= window.innerHeight) revealObserver.observe(element);
    });
  };

  const applyPreference = () => {
    document.documentElement.toggleAttribute('data-reduced-motion', reducedMotion.matches);

    document.querySelectorAll('video > img:not([alt])').forEach((image) => {
      image.setAttribute('alt', '');
    });

    if (!reducedMotion.matches) {
      initializeReveals();
      return;
    }

    revealObserver?.disconnect();
    animations.forEach((animation) => animation.cancel());

    document.querySelectorAll('video[autoplay]').forEach((video) => {
      video.removeAttribute('autoplay');
      video.pause();
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyPreference, { once: true });
  } else {
    applyPreference();
  }

  reducedMotion.addEventListener?.('change', applyPreference);
  document.addEventListener('shopify:section:load', () => initializeReveals());
  window.addEventListener('pagehide', () => {
    animations.forEach((animation) => animation.cancel());
  });
})();
